export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-shrink-0">
              <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-gradient-to-br from-primary-500 via-accent-500 to-accent-700 flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="relative z-10 text-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 mx-auto bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                    <i className="ri-smartphone-line text-3xl md:text-4xl text-white"></i>
                  </div>
                  <p className="mt-3 text-white font-heading text-lg font-bold">90影院</p>
                  <p className="text-white/70 text-xs mt-1">手机观影更便捷</p>
                </div>
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">移动观影</h2>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed max-w-lg mx-auto lg:mx-0">
                90影院全面适配手机、平板等移动设备，随时随地畅享高清影视。支持横竖屏自由切换，流量优化播放模式，地铁通勤、睡前追剧，精彩不停歇。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-800/60 border border-background-700/40 cursor-pointer hover:border-primary-500/40 transition-all">
                  <i className="ri-android-line text-2xl text-accent-400"></i>
                  <div className="text-left">
                    <p className="text-xs text-foreground-400">Android 版本</p>
                    <p className="text-sm font-medium text-white">v3.2.1</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-800/60 border border-background-700/40 cursor-pointer hover:border-primary-500/40 transition-all">
                  <i className="ri-apple-line text-2xl text-accent-400"></i>
                  <div className="text-left">
                    <p className="text-xs text-foreground-400">iOS 版本</p>
                    <p className="text-sm font-medium text-white">v3.2.1</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}